import React, { useState, useEffect, Suspense } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Route, Switch, useHistory, Redirect,
  useLocation
} from 'react-router-dom';
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { OnboardingAxios, ProgramSetupAxios, IAMAxios, ConfigurationAxios, NetworkAxios, UserActivityAxios } from "./API";
import LandingLayout from './shared/layout/LandingLayout';
import Dashboard from "./pages/dashboard/dashboard";
import Journey from './components/Journey/Journey';
import JourneyStage from './components/Journey/JourneyStage';
import Login from './components/User/Login';
import Forums from './pages/forums/forums';

import ThemeSlice from "./store/theme/themeSlice";

import SolutionList from './components/gallery/solutionList';
import ViewSolution from './components/gallery/viewSolution';
import { loginRequest } from './authConfig.js';

import './App.css';
import { camelCase } from 'lodash';
import Connections from './components/connections/Connections';

import Profile from "./shared/profile/Profile";
import MdConclave from './components/MdConclave/MdConclave';
import authSlice from './store/auth/authSlice';
import ImportData from './pages/admin/ImportData';
import NotFound from './shared/layout/NotFound';
import Root from './pages/landingPage/root';
import Onboarding from './pages/onboarding/onboarding';


function App() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.theme);

  const profileConfig = useSelector((state) => state.auth.profileConfig);
  const userTokenData = useSelector((state) => state.auth.tokenData);
  const userDetails = useSelector((state) => state.auth.loggedInUser);

  const { instance, inProgress, accounts } = useMsal();

  const [programList, setProgramList] = useState([
    {
      program: "dark",
      theme: "darkTheme"
    },
    {
      program: "light",
      theme: "lightTheme"
    },
    {
      program: "space",
      theme: "space"
    }
  ]);

  useEffect(() => {

    if (userTokenData == null || userTokenData == undefined || userTokenData == "undefined" || userTokenData == "" || Object.keys(userTokenData).length == 0) {
      const request = {
        ...loginRequest,
        account: accounts[0]
      };
      if (inProgress === InteractionStatus.None) {
        instance.acquireTokenSilent(request).then((response) => {
          IAMAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          ConfigurationAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          ProgramSetupAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          OnboardingAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          NetworkAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          UserActivityAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          dispatch(authSlice.actions.setTokenData(response));
          setTimeout(function () { RefreshToken(); }, new Date(response.expiresOn) - new Date());
          if (location.pathname == "/" || location.pathname == "/login") {
            history.push("/login");
          }
        }).catch((error) => {

          instance.acquireTokenRedirect(request).then((response) => {
            IAMAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
            ConfigurationAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
            ProgramSetupAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
            OnboardingAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
            NetworkAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
            UserActivityAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
            dispatch(authSlice.actions.setTokenData(response));
            setTimeout(function () { RefreshToken(); }, new Date(response.expiresOn) - new Date());
            history.push("/login");
          });
        });
      }
    }
    else {
      IAMAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
      ConfigurationAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
      ProgramSetupAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
      OnboardingAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
      NetworkAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
      UserActivityAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
      if (location.pathname == "/" || location.pathname == "/login") {
        history.push("/login");
      }
    }
  }, [instance, accounts, inProgress]);

  const RefreshToken = () => {
    const request = {
      ...loginRequest,
      account: accounts[0]
    };
    if (inProgress === InteractionStatus.None) {
      instance.acquireTokenSilent(request).then((response) => {
        IAMAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
        ConfigurationAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
        ProgramSetupAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
        OnboardingAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
        NetworkAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
        UserActivityAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
        dispatch(authSlice.actions.setTokenData(response));
        setTimeout(function () { RefreshToken(); }, new Date(response.expiresOn) - new Date());
      }).catch((error) => {
        instance.acquireTokenRedirect(request).then((response) => {
          IAMAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          ConfigurationAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          ProgramSetupAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          OnboardingAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          NetworkAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          UserActivityAxios.defaults.headers.common["Authorization"] = `Bearer ${response.accessToken}`;
          dispatch(authSlice.actions.setTokenData(response));
          setTimeout(function () { RefreshToken(); }, new Date(response.expiresOn) - new Date());
          history.push("/login");
        });
      });
    }
  }
  function PrivateRoute({ children, ...rest }) {
    let tokenData = userTokenData;

    return (
      <Route
        {...rest}
        render={({ location }) =>
          (tokenData && tokenData.accessToken !== undefined && tokenData.accessToken !== null && tokenData.accessToken !== "") ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location }
              }}
            />
          )
        }
      />
    );
  }

  const programHandler = (theme, program) => {
    dispatch(ThemeSlice.actions.setTheme({ theme: theme, program: program }));
  };


  useEffect(() => {
    IAMAxios.interceptors.response.use(
      response => response,
      error => {
        const { status } = error.response;
        if (status === 401) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = window.location.origin;
        }
        return Promise.reject(error);
      }
    );
    ConfigurationAxios.interceptors.response.use(
      response => response,
      error => {
        const { status } = error.response;
        if (status === 401) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = window.location.origin;
        }
        return Promise.reject(error);
      }
    );

    ProgramSetupAxios.interceptors.response.use(
      response => response,
      error => {
        const { status } = error.response;
        if (status === 401) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = window.location.origin;
        }
        return Promise.reject(error);
      }
    );

    OnboardingAxios.interceptors.response.use(
      response => response,
      error => {
        const { status } = error.response;
        if (status === 401) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = window.location.origin;
        }
        return Promise.reject(error);
      }
    );

    NetworkAxios.interceptors.response.use(
      response => response,
      error => {
        const { status } = error.response;
        if (status === 401) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = window.location.origin;
        }
        return Promise.reject(error);
      }
    );

    UserActivityAxios.interceptors.response.use(
      response => response,
      error => {
        const { status } = error.response;
        if (status === 401) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = window.location.origin;
        }
        return Promise.reject(error);
      }
    );

  }, [])
  return (
    <>
      <link rel="stylesheet" type="text/css" href={window.location.origin + theme} />
      <div className="App">
        {!theme &&
          programList.map(item => <div key={item.theme} onClick={() => { programHandler(item.theme, item.program) }} style={{ margin: "5%", padding: "10px", border: "1px solid", width: "250px", margin: "auto" }}>{item.program}</div>)
        }
        {theme &&
          <Switch>
            <Route path="/login" exact>
              <Login />
            </Route>
            <Route path="/home" exact>
              <LandingLayout >
                <Dashboard />
              </LandingLayout>
            </Route>
            <Route path="/connections" exact>
              <LandingLayout >
                <Connections />
              </LandingLayout>
            </Route>
            <Route path="/forum" exact>
              <LandingLayout >
                <Forums />
              </LandingLayout>
            </Route>
            <Route path="/mission" exact>
              <LandingLayout >
                <Journey />
              </LandingLayout>
            </Route>
            <Route path="/mission/stage" exact>
              <LandingLayout >
                <JourneyStage />
              </LandingLayout>
            </Route>
            <Route path="/gallery" exact>
              <LandingLayout hideRightPanel={true}>
                <SolutionList />
              </LandingLayout>
            </Route>
            <Route path="/viewSolution/:solutionId/:teamId" exact>
              <LandingLayout hideRightPanel={true}>
                <ViewSolution />
              </LandingLayout>
            </Route>

            <Route path="/import-data" exact>
              <LandingLayout hideRightPanel={true}>
                <ImportData />
              </LandingLayout>
            </Route>

            <Route path="/root" exact>
              <Root />
            </Route>
            <Route path="/onboarding" exact>
              <Suspense fallback={<div></div>}>
                <Onboarding />
              </Suspense>
            </Route>

            {userDetails.roleId === 5 &&
              <Route path="/md-conclave" exact>
                <LandingLayout >
                  <MdConclave />
                </LandingLayout>
              </Route>
            }


          </Switch>

        }

      </div>

    </>
  );
}

export default App;


